import { Grid, styled } from '@mui/material';
import React from 'react';
import { CalendarShiftItem, CalendarShiftRowPlaceholder } from './calendar-shift-item';
import { CalendarShiftColumnSlot } from '../../helpers/build-calendar-shift-column-layout';

type CalendarDayColumnProps = {
  data: CalendarShiftColumnSlot[];
  dayCount: number;
  dayKey: string;
};

export const CalendarDayColumn = React.memo(
  ({ data, dayCount, dayKey }: CalendarDayColumnProps) => {
    return (
      <ShiftWrapper item dayCount={dayCount}>
        {data.map((shift, rowIndex) =>
          shift != null ? (
            <CalendarShiftItem key={shift.id} shiftData={shift} />
          ) : (
            <CalendarShiftRowPlaceholder
              key={`${dayKey}-empty-${rowIndex}`}
              item
              data-testid={`shift-row-placeholder-${dayKey}-${rowIndex}`}
            />
          )
        )}
      </ShiftWrapper>
    );
  },
  (prev, next) => {
    if (prev.data.length !== next.data.length) {
      return false;
    }
    for (let i = 0; i < prev.data.length; i++) {
      const previousShift = prev.data[i];
      const nextShift = next.data[i];
      if (previousShift?.id !== nextShift?.id) {
        return false;
      }
      if (JSON.stringify(previousShift) !== JSON.stringify(nextShift)) {
        return false;
      }
    }
    if (prev.dayKey !== next.dayKey) {
      return false;
    }
    return true;
  }
);

const ShiftWrapper = styled(Grid, { shouldForwardProp: (prop) => prop !== 'dayCount' })<{
  dayCount: number;
}>(({ theme, dayCount }) => ({
  width: `calc(100% / ${dayCount})`,
  padding: theme.spacing(2),
  '&:last-child': {
    borderRight: 'none',
  },
}));
